import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreSearchApiUrlPrefix } from 'library-@/config/constants';
import type { ApiImageToTextResponse, Image2Text, ApiGetSemanticIdRequest, ApiGetSemanticIdResponse, GetSemanticId } from './interface/ai-image.interface';

export const AiImageApiService = Symbol('AiImageApiService');

export type AiImageApiService = PsHttpService;

@injectable()
export class AiImageApiServiceImpl extends PsHttpService
  implements Image2Text, GetSemanticId {

  get options() {
    return {
      baseURL: coreSearchApiUrlPrefix,
      headers: {
        'X-API-Version': '2.0',
      },
    };
  }

  public async image2text(taskId: string, desc: string, data: any) {
    const res = await this.post<PatSnapCommonResponseData<ApiImageToTextResponse>>({
      url: '/ai-search/image2text',
      params: { task_id: taskId, desc },
      data,
      transformCode: true,
    });

    return res.data;
  }

  public async getSemanticId(data: ApiGetSemanticIdRequest) {
    const res = await this.post<PatSnapCommonResponseData<ApiGetSemanticIdResponse>>({
      url: '/input/search/semantic',
      data,
      transformCode: true,
    });
    return res.data;
  }
}